import React from 'react';
import PropTypes from 'prop-types';
import OutlineInsertPhoto from 'react-md-icon/dist/OutlineInsertPhoto';
import OutlineInsertDriveFile from 'react-md-icon/dist/OutlineInsertDriveFile';
import OutlineClear from 'react-md-icon/dist/OutlineClear';
import { Button } from 'reactstrap';

const UploadContent = ({ file, handleClose, contentSize }) => {
  const iconStyles = { fontSize: contentSize, color: 'var(--color-neutral-300)' };
  const icon = file.type.indexOf('image') > -1 ? <OutlineInsertPhoto style={iconStyles} /> : <OutlineInsertDriveFile style={iconStyles} />;
  return (
    <div className="text-center d-flex align-items-center flex-column p-3 position-relative">
      <Button
        color="white"
        size="sm"
        className="close upload-cancel position-absolute"
        onClick={handleClose}
      >
        <OutlineClear style={{ fontSize: '1.5rem', color: 'var(--color-neutral-500)' }} />
      </Button>
      <h4 style={{ marginBottom: '24px' }}>{icon}</h4>
      <h5 className="text-dark mb-0">{file.name}</h5>
    </div>
  );
};

UploadContent.propTypes = {
  file: PropTypes.shape({
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
  handleClose: PropTypes.func.isRequired,
  contentSize: PropTypes.string.isRequired,
};

export default UploadContent;



// WEBPACK FOOTER //
// ./src/components/UploadDropzone/UploadContent.jsx